import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'order',
    serviceName: 'auth',
    query: gql`
      query order(
        $call_me: Int
        $fast_send: Int
        $user_ids: [String]
        $shop_ids: [String]
        $booth_ids: [String]
        $tracking_codes: [String]
        $page: Int
        $limit: Int
        $for_admin: Int
        $status_ids: [String]
        $cellphones: [String]
        $min_created_at: String
        $min_created_at_equality: String
        $max_created_at: String
        $max_created_at_equality: String
      ) {
        order(
          call_me: $call_me
          fast_send: $fast_send
          user_ids: $user_ids
          shop_ids: $shop_ids
          booth_ids: $booth_ids
          tracking_codes: $tracking_codes
          page: $page
          limit: $limit
          for_admin: $for_admin
          status_ids: $status_ids
          cellphones: $cellphones
          min_created_at: $min_created_at
          min_created_at_equality: $min_created_at_equality
          max_created_at: $max_created_at
          max_created_at_equality: $max_created_at_equality
        ) {
          total
          data {
            id
            call_me
            fast_send
            total_cost
            created_at
            demand_time
            delivery_time
            tracking_code
            shipping_cost
            status {
              id
              title
            }
            shop {
              id
              title
            }
            shipping {
              id
              type {
                id
              }
            }
            payment_type {
              id
            }
            payment_status {
              id
            }
            customer {
              id
              firstname
              lastname
              cellphone
            }
          }
        }
      }
    `,
  },
};

export default schema;
